import Axios from 'axios'
import rateLimit from 'axios-rate-limit'
import {
	addSubdomainInterceptor,
	devInterceptor,
	requestInterceptor,
	responseOnFulfilled,
	responseOnRejected,
} from './interceptors'

const headers = {
	'Content-Type': 'application/json',
	'Cache-Control': 'no-cache',
}

const baseURL = import.meta.env.VITE_API_BASEURL

const instance = Axios.create({ baseURL, headers })

instance.interceptors.request.use(devInterceptor)
instance.interceptors.request.use(addSubdomainInterceptor)
instance.interceptors.request.use(requestInterceptor)

instance.interceptors.response.use(responseOnFulfilled, responseOnRejected)

const apiInstance = rateLimit(instance, {
	maxRequests: 6,
	perMilliseconds: 150,
})

const appInstance = Axios.create({ baseURL: baseURL + 'app', headers })

appInstance.interceptors.request.use(devInterceptor)
appInstance.interceptors.request.use(requestInterceptor)

appInstance.interceptors.response.use(responseOnFulfilled, responseOnRejected)
appInstance.defaults.meta = { name: 'app' }

export { apiInstance, appInstance }
